import { render, staticRenderFns } from "./MyMileage.vue?vue&type=template&id=bcc872c4&scoped=true"
import script from "./MyMileage.vue?vue&type=script&lang=js"
export * from "./MyMileage.vue?vue&type=script&lang=js"
import style0 from "./MyMileage.vue?vue&type=style&index=0&id=bcc872c4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc872c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcc872c4')) {
      api.createRecord('bcc872c4', component.options)
    } else {
      api.reload('bcc872c4', component.options)
    }
    module.hot.accept("./MyMileage.vue?vue&type=template&id=bcc872c4&scoped=true", function () {
      api.rerender('bcc872c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/MyMileage.vue"
export default component.exports